import Detail from './Detail';

const Components = {
    Detail : Detail
}

export default Components;